import React, { useContext, useEffect, useRef } from 'react';
import { useMediaQuery } from '@mui/material';
import { CommonFilterFields } from 'constants/filters/commonFilterFields';
import { Controller, useWatch } from 'react-hook-form';
import MultiSelect from 'components/atoms/multiSelect/MultiSelect';
import { FilterFormCtx } from '../filterFormCtx';
import { dateRanges } from './dateRanges';

export function PredefinedDateRange() {
  const isTablet = useMediaQuery('(max-width: 1280px)');
  const rangeDates = useRef(null);
  const { setValue, control, onSubmit } = useContext(FilterFormCtx);

  const startDate = useWatch({
    name: 'startDate',
    control,
  });
  const endDate = useWatch({
    name: 'endDate',
    control,
  });

  useEffect(() => {
    const current = rangeDates.current;

    if (current && (current?.start !== startDate || current?.end !== endDate)) {
      setValue(CommonFilterFields.DATE_RANGE.key, dateRanges.CUSTOM);
    }
  }, [startDate, endDate, setValue]);

  const onChange = (option) => {
    rangeDates.current = null;

    if (option.value) {
      const value = (rangeDates.current = option.value());
      setValue(CommonFilterFields.START_DATE.key, value.start);
      setValue(CommonFilterFields.END_DATE.key, value.end);
      if (isTablet) {
        onSubmit();
      }
    }
  };

  return (
    <Controller
      control={control}
      name={CommonFilterFields.DATE_RANGE.key}
      render={({ field }) => (
        <MultiSelect
          controllerField={field}
          className='lg:w-52'
          options={dateRanges}
          sortOptions={false}
          placeholder='Date Range'
          isClearable={false}
          isMulti={CommonFilterFields.DATE_RANGE.isMulti}
          onChange={onChange}
        />
      )}
    />
  );
}
